<script>
	import Buttons from "./components/Buttons.svelte";

	import annotationArrow from "./icons/annotation_arrow.svg";

	import arrowLeft from "./icons/arrow_left.svg";
	import arrowRight from "./icons/arrow_right.svg";

	import emojiStronglyReject from "./icons/strongly_reject.png";
	import emojiReject from "./icons/reject.png";
	import emojiNeutral from "./icons/neutral.png";
	import emojiApprove from "./icons/approve.png";
	import emojiStronglyApprove from "./icons/strongly_approve.png";

	export let name;
	export let votes;
	export let options;
	export let annotations = [];
	export let symbols = [];
	export let votesForOption = [];


	let selected = (options.find((o) => o.selected) || options[0]).id;

	options.forEach((o) => {
		o.value = o.id;
	});

	const ticks = [
		{ id: "strongly_reject", emoji: emojiStronglyReject },
		{ id: "reject", emoji: emojiReject },
		{ id: "neutral", emoji: emojiNeutral },
		{ id: "approve", emoji: emojiApprove },
		{ id: "strongly_approve", emoji: emojiStronglyApprove },
	];
</script>

<div class="result" id={name}>
	<div class="ui">
		<div class="buttons-container">
			<Buttons bind:value={selected} {options} let:option let:active>
				<div class="main">
					{@html option.label}
				</div>
			</Buttons>
		</div>
	</div>
	{#each votesForOption as v, i}
	{#if v.id === selected}
		<div class="annotation-distribution">Verteilung der Antworten (N = {v.count})</div>
	{/if}
	  {/each}
	<div class="chart-container">
		<img class="violin" src="{PATH}assets/{name}_{selected}.svg" alt="" />
		<img class="annotation-arrow" src={annotationArrow} alt="" />
		<div class="axis">
			<div class="axis-line" />
			<div class="ticks">
				{#each ticks as t}
					<div class="tick">
						<div class="line" />
						<img class="emoji" src={t.emoji} alt="" />
					</div>
				{/each}
			</div>
		</div>

		{#each annotations as a, i}
			{#if a.id === selected || a.id === "showAlways"}
			<div
				class="annotation"
				id={a.id}
				class:left={a.left < 10}
				class:right={a.left > 94}
				style:color={a.color}
				style:left="{a.left}%"
				style:top="{a.top}%"
			>
				<div>{@html a.label}</div>
				<div class="line" style:background-color={a.color} style:height="{a.line_length}%" />
			</div>
			{/if}
		{/each}

    {#each symbols as s, i}
      {#if s.shape === 'circle' && s.id === selected}
			<div
				class="symbol {s.shape}"
				id={s.id}
				style:left="{s.left}%"
				style:top="{s.top}%"
				style:width="{s.size}px"
				style:height="{s.size}px"
				style:background-color={s.color}
        />
      {/if}
		{/each}

		{#each symbols as s, i}
		{#if s.shape === 'circle' && s.id === "showAlways"}
			  <div
				  class="symbol {s.shape}"
				  id={s.id}
				  style:left="{s.left}%"
				  style:top="{s.top}%"
				  style:width="{s.size}px"
				  style:height="{s.size}px"
				  style:background-color={s.color}
		  />
		{/if}
		  {/each}

		{#each symbols as s, i}
		{#if s.shape === 'diamond' && s.id === selected}
			  <div
				  class="symbol {s.shape}"
				  id={s.id}
				  style:left="{s.left}%"
				  style:top="{s.top}%"
				  style:width="{s.size}px"
				  style:height="{s.size}px"
				  style:background-color={s.color}
		  />
		{/if}
		  {/each}

		
	</div>
	<div class="legend">
		<div class="approve">Ablehnung<img src={arrowLeft} alt="" /></div>
		<div class="reject"><img src={arrowRight} alt="" />Zustimmung</div>
	</div>
</div>

<style lang="scss">
	@import "./main.scss";

	b {font-weight: 500 !important;}

	.result {
		font-family: $ff-sans;
		font-size: $fs-base;
		line-height: $lh-base;
		color: $color;
		position: relative;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 60px;
	}

	.ui {
		width: 100%;
		margin-bottom: 10px;
	}

	.annotation-distribution {
		color: #606a62;
	}

	.chart-container {
		width: 100%;
		height: 100%;
		position: relative;
		display: flex;
		margin: 0 10px;
		min-height: 190px;

		@media (max-width: $breakpoint-mobile-l) {
			min-height: 150px;
		}

		.violin {
			width: 100%;

			@media (max-width: $breakpoint-mobile-m) {
					transform: scaleY(1.5)
				}
		}

		.annotation-arrow {
			position: absolute;
			height: 40%;
			left: 10%;
			top: 5%;
			width: unset;
		}

		.annotation {
			$lh: 17px;
			$top: 8%;

			position: absolute;
			transform: translate(-50%, 0);
			text-align: center;
			white-space: nowrap;
			line-height: $lh;
			height: 100%;
			display: flex;
			align-items: center;
			flex-direction: column;
			top: $top;
			text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;

			.line {
				background: $black;
				height: calc(50% - #{$lh} - #{$top});
				width: 1px;
				transform: translateX(-0.5px);
			}

			&.left {
				transform: translate(0, 0);
				align-items: flex-start;
			}

			&.right {
				text-align: right;
				transform: translate(-100%, 0);
				align-items: flex-end;
			}
		}

		.symbol {
			position: absolute;
			border: 2px solid white;
			background-color: $black;
			top: 50%;
			transform: translate(-50%, -50%);

			&.circle {
				width: 13px;
				height: 13px;
				border-radius: 100%;

				@media (max-width: $breakpoint-mobile-m) {
					width: 10px;
					height: 10px;
				}
			}

			&.diamond {
				width: 14px;
				height: 14px;
				transform: translate(-50%, -50%) rotate(45deg);

				@media (max-width: $breakpoint-mobile-m) {
					width: 8px;
					height: 8px;
				}
			}
		}
	}

	.axis {
		position: absolute;
		width: 100%;
		bottom: 0px;
		height: 50%;

		.axis-line {
			width: 100%;
			height: 1px;
			top: 0;
			position: absolute;
			transform: translateY(-0.5px);
			background: $grey;
		}

		.ticks {
			display: flex;
			justify-content: space-between;
			position: absolute;
			width: 100%;
			bottom: 0px;
			height: 100%;
			align-items: flex-end;
		}

		.tick {
			display: flex;
			flex-direction: column;
			align-items: center;
			height: 100%;

			&:nth-child(1),
			&:nth-child(2) {
				transform: translateX(-50%);
			}
			&:nth-child(4),
			&:nth-child(5) {
				transform: translateX(50%);
			}

			.line {
				width: 1px;
				height: 100%;
				background: $grey;
				opacity: 0.3;
			}

			.emoji {
				width: 20px;
				margin-top: 3px;
			}
		}
	}

	.legend {
		width: 63%;
		position: relative;
		left:calc((100% - 63%)/2);

		display: flex;
		justify-content: space-between;
		margin-top: 15px;
		color: $grey;

		@media (max-width: $breakpoint-mobile-m) {
					width: 72%;
					left:15%;
				}

		.approve img {
			margin-left: 8px;
			width: 30px;
			display: inline-block;
		}

		.reject img {
			margin-right: 8px;
			width: 30px;
			display: inline-block;
		}
	}

	// desktop
	@media (min-width: #{$breakpoint-tablet-l + 1px}) {
	}

	// large tablets
	@media (min-width: #{$breakpoint-tablet-s + 1px}) and (max-width: $breakpoint-tablet-l) {
	}

	// small tablets
	@media (min-width: #{$breakpoint-mobile-l + 1px}) and (max-width: $breakpoint-tablet-s) {
	}

	// large/normal phones
	@media (min-width: #{$breakpoint-mobile-m + 1px}) and (max-width: $breakpoint-mobile-l) {
	}

	// small phones
	@media (min-width: #{$breakpoint-mobile-s + 1px}) and (max-width: $breakpoint-mobile-m) {
	}

	// verz small phones
	@media (max-width: $breakpoint-mobile-s) {
	}
</style>
